import React from 'react';
import { components } from 'react-select';
import BaseSingleValue from '../components/base-single-value';
const renderSingleValue = (Component = BaseSingleValue) => {
  const SingleValue = components.SingleValue;

  const SingleValueWrapper = (props) => {
    const { data, ...restProps } = props;
    return (
      <SingleValue {...props} isDisabled={!!data.disabled}>
        <Component {...data} {...restProps} isDisabled={!!data.disabled} />
      </SingleValue>
    );
  };

  SingleValueWrapper.displayName = 'SingleValueWrapper';

  return SingleValueWrapper;
};

export default renderSingleValue;
